<template>
  <div>
    <!-- Modal -->
    <div 
      class="modal fade" 
      id="modalAccessoriesSwitch" 
      tabindex="-1" 
      role="dialog" 
      aria-labelledby="accessoriesSwitchModalLabel" 
      ref="modal"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header border-bottom">
            <h5 class="modal-title font-weight-bold" id="accessoriesSwitchModalLabel">
              Switch Accessories
            </h5>
            <button type="button" class="close" @click="closeModal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <!-- Modal Body -->
          <div class="modal-body">
            <div v-if="orderData.dataAccessories && orderData.dataAccessories.batchNo">
              <!-- Order Info -->
              <div class="mb-3">
                <h6 class="section-label">Order Info</h6>
                <div class="info-card">
                  <div class="mb-1 font-weight-600">{{ orderData.companyName }}</div>
                  <div 
                    v-if="orderData.orderCode" 
                    class="text-primary" 
                    style="cursor: pointer;"
                    @click="toOrderDetail(orderData.orderId, orderData.orderCode, orderData.companyId)"
                  >
                    {{ orderData.orderCode }}
                  </div>
                </div>
              </div>

              <!-- Product Info -->
              <div class="mb-3">
                <h6 class="section-label">Product Info</h6>
                <div class="info-card">
                  <div class="text-muted small mb-1">Accessories</div>
                  <div class="font-weight-600 mb-3">
                    {{ orderData.dataAccessories ? orderData.dataAccessories.itemName : '-' }}
                  </div>
                  <div class="row">
                    <div class="col-6 mb-2">
                      <div class="detail-label">Product Code</div>
                      <div class="detail-value">{{ orderData.dataAccessories ? orderData.dataAccessories.itemCode || '-' : '-' }}</div>
                    </div>
                    <div class="col-6 mb-2">
                      <div class="detail-label">Serial Number</div>
                      <div class="detail-value">{{ orderData.dataAccessories ? orderData.dataAccessories.serialNumber || '-' : '-' }}</div>
                    </div>
                    <div class="col-6">
                      <div class="detail-label">Stock Code</div>
                      <div class="detail-value">{{ orderData.dataAccessories ? orderData.dataAccessories.stockCode || '-' : '-' }}</div>
                    </div>
                    <div class="col-6">
                      <div class="detail-label">Batch Number</div>
                      <div class="detail-value">{{ orderData.dataAccessories ? orderData.dataAccessories.batchNo || '-' : '-' }}</div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Pilih Accessories -->
              <div class="mb-3">
                <h6 class="section-label">Pilih Accessories</h6>
                <div class="info-card">
                  <!-- Accessories Name -->
                  <div class="mb-3">
                    <label class="form-label-bold">Accessories Name</label>
                    <p class="form-hint">Pilih accessories pengganti dari list yang tersedia</p>
                    <multiselect 
                      v-model="selectedAccessory"
                      :options="accessoriesOptions" 
                      label="itemName"
                      :allow-empty="false"
                      :select-label="''"
                      :deselect-label="''"
                      placeholder="Pilih accessories yang akan ditukar"
                    ></multiselect>
                  </div>

                  <!-- Opsi Batch Number -->
                  <div>
                    <label class="form-label-bold">Opsi Batch Number</label>
                    <p class="form-hint">Pilih opsi sesuai kondisi label stiker pada item</p>
                    <div class="row no-gutters">
                       <!-- Memiliki Batch Number -->
                      <div class="col-6 pr-2">
                        <div 
                          class="batch-option-card"
                          :class="batchOption === 'with' ? 'batch-option-card--active' : ''"
                          @click="batchOption = 'with'"
                        >
                          <div class="batch-option-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                              <rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/>
                              <line x1="9" y1="21" x2="9" y2="9"/>
                            </svg>
                          </div>
                          <div class="batch-option-text">
                            <div class="batch-option-title">Memiliki Batch Number</div>
                            <div class="batch-option-desc">Item sudah ada label stiker nomor batch</div>
                          </div>
                          <div class="custom-control custom-radio ml-2">
                            <input type="radio" class="custom-control-input" id="radioWithBatch" name="batchOption" value="with" v-model="batchOption">
                            <label class="custom-control-label" for="radioWithBatch"></label>
                          </div>
                        </div>
                      </div>

                      <!-- Tanpa Batch Number -->
                      <div class="col-6 pl-2">
                        <div 
                          class="batch-option-card"
                          :class="batchOption === 'without' ? 'batch-option-card--active' : ''"
                          @click="batchOption = 'without'"
                        >
                          <div class="batch-option-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                              <rect x="3" y="3" width="18" height="18" rx="2"/><line x1="3" y1="9" x2="21" y2="9"/>
                            </svg>
                          </div>
                          <div class="batch-option-text">
                            <div class="batch-option-title">Tanpa Batch Number</div>
                            <div class="batch-option-desc">Item belum ada label stiker nomor batch</div>
                          </div>
                          <div class="custom-control custom-radio ml-2">
                            <input type="radio" class="custom-control-input" id="radioWithoutBatch" name="batchOption" value="without" v-model="batchOption">
                            <label class="custom-control-label" for="radioWithoutBatch"></label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <div v-else>
              <div class="p-3 bg-light rounded mb-3">
                <!-- Company Info -->
                <div class="row mb-3">
                  <div class="col-4">
                    <strong>Company Info:</strong>
                  </div>
                  <div class="col-8">
                    {{orderData.companyName}}
                  </div>
                </div>

                <!-- Order ID -->
                <div class="row mb-1">
                  <div class="col-4">
                    <strong>Order ID:</strong>
                  </div>
                  <div class="col-8">
                    <div v-if="orderData.orderCode" class="text-primary" style="cursor: pointer;" @click="toOrderDetail(orderData.orderId, orderData.orderCode,orderData.companyId)">{{orderData.orderCode}}</div>
                    <!-- <a :href="orderInfo.link" class="text-primary">
                      {{ orderData.co }}
                    </a> -->
                  </div>
                </div>
              </div>

              <!-- Accessories -->
              <div class="p-3 bg-light rounded mb-3">
                <div class="row mb-2">
                  <div class="col-4">
                    <strong>Accessories:</strong>
                  </div>
                  <div class="col-8">
                    {{ orderData.dataAccessories ? orderData.dataAccessories.itemName : '' }}
                  </div>
                </div>

                <!-- Total Units -->
                <div class="row mb-1 d-flex" style="justify-content: space-between;">
                  <div class="col-4">
                    <strong>Total Unmatch:</strong>
                  </div>
                  <div class="col-8 desc-info">
                    {{ orderData.unmatchQty}} units
                  </div>
                </div>

                <div class="row mb-1">
                  <div class="col-4">
                    <strong>Total Allocated:</strong>
                  </div>
                  <div class="col-8">
                    {{ allocatedQty}} units
                  </div>
                </div>

                <div class="row mb-1">
                  <div class="col-4">
                    <strong>Remaining:</strong>
                  </div>
                  <div class="col-8" :style="`color: ${orderData.unmatchQty - allocatedQty >= 0 ? '#4DA167;' : '#BE3846;'}`">
                    {{ orderData.unmatchQty - allocatedQty}} units
                  </div>
                </div>
              </div>

              <!-- Allocation -->
              <div class="section-header">
                <h6 class="section-title">Allocation to Catalogs</h6>
                <button class="btn-add-allocation" @click="addAllocation" v-if="orderData.unmatchQty - allocations.length > 0">
                  <i class="fas fa-plus"></i>
                  <span>Add Allocation</span>
                </button>
              </div>
              <div v-for="(allocation, index) in allocations" :key="index" class="allocation-card">
                <div class="allocation-header">
                  <div class="allocation-title">Allocation {{ index + 1 }}</div>
                  <button class="btn-close-allocation" @click="removeAllocation(index)" v-if="allocations.length > 1">
                    <span>&times;</span>
                  </button>
                </div>
                <div class="row">
                  <div class="col-md-8 col-sm-12 mb-3 mb-md-0">
                    <label class="form-label">Accessories Name</label>
                    <div class="search-input-wrapper">
                      <multiselect v-model="allocation.accessories" :options="accessoriesOptions" label="itemName" :allow-empty="false" :select-label="''" :deselect-label="''" placeholder="Search by name"></multiselect>
                      <!-- <i class="fas fa-search search-icon"></i> -->
                      <!-- <input 
                        type="text" 
                        class="form-control" 
                        placeholder="Search by name"
                        v-model="allocation.accessories.itemName"
                      > -->
                    </div>
                    
                  </div>
                  <div class="col-md-4 col-sm-12">
                    <label class="form-label">Quantity</label>
                    <div class="quantity-input">
                      <input 
                        type="number" 
                        class="form-control" 
                        placeholder="Quantity"
                        v-model="allocation.qty"
                        min="0"
                      >
                    </div>
                  </div>
                </div>
              </div>
              </div>

          </div>

          <!-- Modal Footer -->
          <div class="modal-footer border-top">
            <button type="button" class="btn btn-outline-secondary" @click="closeModal">
              Cancel
            </button>
            <button 
              type="button" 
              class="btn btn-primary" 
              @click="confirmSwitch"
            >
              Confirm Switch
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Multiselect from 'vue-multiselect';

export default {
  name: 'modalAccessoriesSwitch',
  components: {
    Multiselect
  },
  props: ['orderData','toOrderDetail'],
  data() {
    return {
      hasBatchNumber: false,
      unmatchedUnits: 1,
      allocationQty : 0,
      allocations : [
        {
          accessories : null,
          qty : 0,
        }
      ],
      accessoriesOptions : [],
      selectedAccessory: null,   // untuk mode batch
      batchOption: '',           // 'with' atau 'without'
    }
  },
  computed: {
    allocatedQty: function() {
      return this.allocations.reduce(function(total, allocation) {
        var qty = parseInt(allocation.qty) || 0;
        return total + qty;
      }, 0);
    }
  },
  methods: {
    getAccessoriesPart() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      this.$http.get(process.env.GET_ACCESSORIES_PART, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(res => {
          if (res.data.status == 200) {
            this.accessoriesOptions = res.data.content
          } else {
            swalWithBootstrapButtons.fire({
              title: "Sorry, we failed to get sparepart data.",
              text: `${res.data.message}`,
              icon: "error",
            })
          }
        })
        .catch(error => {
          swalWithBootstrapButtons.fire({
            title: "Sorry",
            text: `${error.response.data.message}`,
            icon: "error",
          }).then(val => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    getSparepart() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      this.$http.get(process.env.ASSEMBLY_GET_PART + this.orderData.itemGroup, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        .then(res => {
          if (res.data.status == 200) {
            this.accessoriesOptions = res.data.content
          } else {
            swalWithBootstrapButtons.fire({
              title: "Sorry, we failed to get sparepart data.",
              text: `${res.data.message}`,
              icon: "error",
            })
          }
        })
        .catch(error => {
          swalWithBootstrapButtons.fire({
            title: "Sorry",
            text: `${error.response.data.message}`,
            icon: "error",
          }).then(val => {
            if(error.response.data.status == 401) {
              this.handleLogout()
            }
          })
        })
    },
    removeAllocation(index){
      if (this.allocations.length > 1) {
        this.allocations.splice(index, 1);
      }
    },
    addAllocation() {
      this.allocations.push({accessoriesName : '', qty : 0})
    },
    showModal() {
      // Reset unmatched units ketika modal dibuka
      this.unmatchedUnits = 1;
      $(this.$refs.modal).modal('show');
    },
    closeModal() {
      this.hasBatchNumber = false;
      this.selectedAccessory = null;
      this.batchOption = '';
      this.allocations = [{ accessories: null, qty: 0 }];
      $(this.$refs.modal).modal('hide');
    },
    confirmSwitch() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      if (this.hasBatchNumber) {
        if (!this.selectedAccessory) {
          Swal.fire({ title: "Error", text: "Pilih accessories pengganti", icon: "error" });
          return;
        }
        if (!this.batchOption) {
          Swal.fire({ title: "Error", text: "Pilih opsi batch number", icon: "error" });
          return;
        }

        const { orderId, dataAccessories, currentLocation } = this.orderData;
        const { itemCode, itemGroup, itemName } = dataAccessories;

        const payload = {
          orderId,
          currentLocation,
          hasBatchNumber: this.batchOption === 'with',
          oldAcc: { itemGroup, itemCode, itemName, qty: 1 },
          switchTo: [{
            itemGroup,
            itemCode: this.selectedAccessory.itemCode,
            itemName: this.selectedAccessory.itemName,
            qty: 1
          }]
        };

        this.processAccessoriesSwitch(payload);
        return;

      } else {
        // Validasi
        let validationErrorMessage = ''
        this.allocations.forEach(item => {
          const {accessories, qty} = item
          if(!accessories) {
            validationErrorMessage = `Accessories Name can't be empty`
          } else if (Number(qty) === 0) {
            validationErrorMessage = `Item Quantity can't be 0`
          }
        })

        if(this.allocatedQty == 0) {
          validationErrorMessage = `Allocated Item Quantity can't be 0`
        } else if (Number(this.allocatedQty) - Number(this.orderData.unmatchQty) !== 0) {
          validationErrorMessage = `Quantity is not match`
        }

        if(validationErrorMessage) {
          swalWithBootstrapButtons.fire({
            title: "Error",
            text: `${validationErrorMessage}`,
            icon: "error",
          })
        } else {
          const {orderId, dataAccessories, currentLocation} = this.orderData
          const {itemCode, itemGroup, itemName, unmatchQty} = dataAccessories
          let newAccessories = this.allocations.map(item => {
            return {
              itemGroup: itemGroup,
              itemCode: item.accessories.itemCode,
              itemName: item.accessories.itemName,
              qty: Number(item.qty)
            }
          })
          const payload = {
            orderId,
            currentLocation,
            oldAcc: {
                itemGroup,
                itemCode,
                itemName,
                qty: unmatchQty
            },
            switchTo:newAccessories
          }
          // console.log(payload)
          this.processAccessoriesSwitch(payload)
        }
      }
      
    },
    processAccessoriesSwitch(payload) {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });

      this.$http.post(process.env.ACCESSORIES_SWITCH, payload, {
          timeout: 30 * 1000,
          headers: { "Asani-Token": localStorage.getItem("jwt") },
        })
        .then(res => {
          if (res.data.status == 200) {
            swalWithBootstrapButtons.fire({
              title: "Success",
              text: `Data has been saved successfully.`,
              icon: "success",
            }).then(result => {
              this.closeModal()
              window.location.reload()
            })
          } else {
            swalWithBootstrapButtons.fire({
              title: "Sorry",
              text: `${res.data.message}`,
              icon: "error",
            })
          }
        })
        .catch(error => {
          this.loadingTable = false
          swalWithBootstrapButtons.fire({
            title: "Sorry",
            text: `${error.response.data.message}`,
            icon: "error",
          }).then(() => {
            this.closeModal()
          })
        })
    },
  },
  watch: {
    unmatchedUnits(newVal) {
      // Pastikan nilai selalu dalam range yang valid
      if (newVal < 1) {
        this.unmatchedUnits = 1;
      } else if (newVal > this.accessories.totalUnits) {
        this.unmatchedUnits = this.accessories.totalUnits;
      }
    },
    orderData(val) {
      if (val && val.dataAccessories) {
        this.hasBatchNumber = !!(val.dataAccessories.batchNo)
        if(val.source == 'accessories') {
          this.getAccessoriesPart()
        } else {
          this.getSparepart()
        }
        this.allocations = [{ accessories: null, qty: 0 }]
        this.selectedAccessory = null
        this.batchOption = ''
      }
    }
  }
}
</script>

<style scoped>
  .section-label {
    font-size: 0.875rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
    color: #212529;
  }
  .info-card {
    border: 1px solid #D1D9E2;
    border-radius: 6px;
    padding: 0.875rem 1rem;
    background-color: #fff;
  }
  .font-weight-600 { font-weight: 600; }
  .detail-label { font-size: 12px; color: #6c757d; margin-bottom: 2px; }
  .detail-value { font-size: 13px; color: #212529; }
  .form-label-bold { font-size: 0.875rem; font-weight: 600; color: #212529; display: block; margin-bottom: 2px; }
  .form-hint { font-size: 12px; color: #6c757d; margin-bottom: 0.5rem; }
  .batch-option-card {
    border: 1px solid #dee2e6;
    border-radius: 6px;
    padding: 0.75rem;
    cursor: pointer;
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    background: #fff;
    transition: border-color 0.15s;
    height: 100%;
  }

  .batch-option-card:hover { border-color: #a0b4f0; }
  .batch-option-card--active { border-color: #0d6efd; background-color: #f0f5ff; }
  .batch-option-icon { color: #495057; flex-shrink: 0; margin-top: 2px; }
  .batch-option-text { flex: 1; }
  .batch-option-title { font-size: 13px; font-weight: 600; color: #212529; }
  .batch-option-desc { font-size: 11px; color: #6c757d; margin-top: 2px; }

  .btn-close-allocation {
    background: none;
    border: none;
    font-size: 1.25rem;
    color: #6c757d;
    cursor: pointer;
    padding-bottom: 1.5rem;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s;
  }

  .btn-close-allocation:hover {
    color: #212529;
  }

  .section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
  }
  .section-title {
    font-size: 1rem;
    font-weight: 600;
    color: #212529;
    margin: 0;
  }

  .btn-add-allocation {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
    padding: 0.5rem 1rem;
    border: 1px solid #dee2e6;
    background-color: #fff;
    color: #495057;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s;
  }

  .btn-add-allocation:hover {
    background-color: #f8f9fa;
    border-color: #adb5bd;
  }

  .btn-add-allocation i {
    font-size: 0.75rem;
  }
  .allocation-card {
    border: 1px solid #dee2e6;
    border-radius: 6px;
    padding: 1.25rem;
    background-color: #fff;
    margin-bottom: 1rem;
  }
  .allocation-card:last-child {
    margin-bottom: 0;
  }

  .allocation-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
  }

  .allocation-title {
    font-size: 0.95rem;
    font-weight: 600;
    margin-bottom: 1rem;
    color: #212529;
  }

  .form-label {
    font-size: 0.875rem;
    font-weight: 600;
    color: #495057;
    margin-bottom: 0.5rem;
    display: block;
  }

  .search-input-wrapper {
    position: relative;
  }

  .search-input-wrapper .form-control {
    padding-left: 2.5rem;
    border-radius: 4px;
    border: 1px solid #ced4da;
    font-size: 0.875rem;
    height: 38px;
  }

  .search-input-wrapper .form-control:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
  }

  .search-input-wrapper .search-icon {
    position: absolute;
    left: 0.75rem;
    top: 50%;
    transform: translateY(-50%);
    color: #6c757d;
    font-size: 0.875rem;
  }
  .quantity-input .form-control {
    border-radius: 4px;
    border: 1px solid #ced4da;
    font-size: 0.875rem;
    height: 38px;
  }
  .quantity-input .form-control:focus {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
  }
.btn-qty {
  width: 38px;
  height: 38px;
  font-size: 18px;
  padding: 0;
  line-height: 1;
}
.border-card {
  border: 1px solid  #CFD3D9;
  border-radius: 8px;
  padding: 10px;
}
.modal-header {
  background-color: #fff;
  padding: 1rem 1.5rem;
}

.modal-body {
  padding: 1.5rem;
}

.modal-footer {
  padding: 1rem 1.5rem;
}

.border-bottom {
  border-bottom: 1px solid #dee2e6 !important;
}

.border-top {
  border-top: 1px solid #dee2e6 !important;
}

.font-weight-bold {
  font-weight: 600;
}

.input-group .btn {
  border-color: #ced4da;
  width: 45px;
}

.input-group .form-control {
  border-left: 0;
  border-right: 0;
}

.input-group-prepend .btn,
.input-group-append .btn {
  z-index: 0;
}

.input-group .form-control:focus {
  box-shadow: none;
  border-color: #ced4da;
}

.alert-warning {
  background-color: #fff3cd;
  border-color: #ffeaa7;
  color: #856404;
}

.btn-warning {
  background-color: #ff7f32;
  border-color: #ff7f32;
}

.btn-warning:hover {
  background-color: #e67329;
  border-color: #e67329;
}

.btn-warning:disabled {
  background-color: #ff7f32;
  border-color: #ff7f32;
  opacity: 0.65;
}

hr {
  margin: 1rem 0;
  border-top: 1px solid #dee2e6;
}
</style>


// WEBPACK FOOTER //
// src/components/QC/CustomComponent/ModalAccessoriesSwitch.vue